var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.168 0.579285H3.36096C1.99922 0.579285 0.885071 1.69343 0.885071 3.05517V22.8623C0.885071 24.224 1.99922 25.3381 3.36096 25.3381H23.168C24.5298 25.3381 25.6439 24.224 25.6439 22.8623V3.05517C25.6439 1.69343 24.5298 0.579285 23.168 0.579285ZM8.31273 21.6243H4.5989V10.4828H8.31273V21.6243ZM6.45581 8.37832C5.21787 8.37832 4.22752 7.38797 4.22752 6.15003C4.22752 4.91208 5.21787 3.92173 6.45581 3.92173C7.69376 3.92173 8.68411 4.91208 8.68411 6.15003C8.68411 7.38797 7.69376 8.37832 6.45581 8.37832ZM21.9301 21.6243H18.2163V15.0632C18.2163 14.0729 17.3497 13.2063 16.3594 13.2063C15.369 13.2063 14.5024 14.0729 14.5024 15.0632V21.6243H10.7886V10.4828H14.5024V11.9684C15.1214 10.978 16.4831 10.2352 17.5973 10.2352C19.9494 10.2352 21.9301 12.2159 21.9301 14.568V21.6243Z",
    fill: "#21C3E7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.b89a49e15bb261065f59b2a9e51d0390.svg";
export { ForwardRef as ReactComponent };